<template>
  <div class="airOrders" v-loading="loading" v-if="ordersData">
    <div class="flights">
      <div class="flights-content" v-for="(item,index) in ordersData.segmentList" :key="index">
        <div class="flights-icon">
          <i></i>
          {{index === 0 ? '去程' : '回程'}}
        </div>
        <div class="flights-contentT df">
          <div class="flights-nub df">
            <img :src="item.airCompanyLogoImg || image_url_airline_blank_map" alt="">
            <div>
              <span>{{item.airCompanyName}}</span>
              <span style="display:block">{{item.flightNo.replace(/,/,'/')}}</span>
              <p>
                {{item.beginDate}}
                <i>{{Getweek(item.beginDate)}}</i>
              </p>
            </div>
          </div>
          <div class="flights-data df">
            <div class="flights-star">
              <h5>{{item.sCityName}}({{item.sAirportCode}}){{item.beginTime}}</h5>
              <span>{{item.sCityName}}{{item.sAirportName}} {{item.sTerminal}}</span>
            </div>
            <div class="arrows">
              <p>{{item.duration.replace(/:/,'小时')}}分钟</p>
              <div
                class="arrows-ico"
                @mouseenter="$set(arrowsInfoShow,index,true)"
                @mouseleave="$set(arrowsInfoShow,index,false)"
              ></div>
              <div class="arrows-stop-info" :class="{'fare-info-animation':arrowsInfoShow[index]}">
                <p class="arrows-stop-info-title">航班详情</p>
                <div class="arrows-stop-info-box">
                  <div class="info-box-title flex-center-end">
                    <span>
                      航班日期:{{item.routeList[0].beginDate}}
                      星期{{new Date(item.routeList[0].beginDate).getDay()==1?'一':
                      new Date(item.routeList[0].beginDate).getDay()==2?'二':
                      new Date(item.routeList[0].beginDate).getDay()==3?'三':
                      new Date(item.routeList[0].beginDate).getDay()==4?'四':
                      new Date(item.routeList[0].beginDate).getDay()==5?'五':
                      new Date(item.routeList[0].beginDate).getDay()==6?'六':'日'}}
                    </span>
                    <span>全程时间:{{item.duration.replace(/:/,'小时')}}分钟</span>
                  </div>
                  <div
                    v-for="(routeListItem,routeListIndex) in item.routeList"
                    :key="routeListIndex"
                  >
                    <div class="info-box-list flex-center-end">
                      <img
                        :src="routeListItem.airCompanyLogoImg || image_url_airline_blank_map"
                        alt=""
                      >
                      <div>
                        <p>{{routeListItem.airCompanyName}}</p>
                        <p>{{routeListItem.flightNo}}</p>
                      </div>
                      <div class="info-box-text">
                        <div class="flex-center-end">
                          <span>起飞: {{routeListItem.beginDate}}</span>
                          <span>{{routeListItem.beginTime}}</span>
                          <span>{{routeListItem.sCityName}}</span>
                          <span>{{routeListItem.sAirportName}}</span>
                        </div>
                        <div class="flex-center-end">
                          <span>降落: {{routeListItem.arriveDate}}</span>
                          <span>{{routeListItem.arriveTime}}</span>
                          <span>{{routeListItem.eCityName}}</span>
                          <span>{{routeListItem.eAirportName}}</span>
                        </div>
                      </div>
                      <div>
                        <span>{{routeListItem.duration.replace(/:/,'h')}}m</span>
                      </div>
                    </div>
                    <div
                      class="info-box-list-hint"
                      v-if="item.routeList.length>1"
                      v-show="(routeListIndex + 1)!==item.routeList.length"
                    >
                      <div class="info-box-list-hint-box flex-center-end">
                        <span>中转: {{routeListItem.eCityName}}</span>
                        <span>停留时长: {{item.durationOfTransitCity.replace(/h/,'小时').replace(/m/,'分钟')}}</span>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div class="flights-end">
              <h5>{{item.arriveTime}}{{item.eCityName}}({{item.eAirportCode}})</h5>
              <span>{{item.eCityName}}{{item.eAirportName}} {{item.eTerminal}}</span>
            </div>
            <div></div>
          </div>
          <div class="flights-more"></div>
        </div>
        <div>
          <div class="fare-style" v-show="orderInfo.flightType==1">
            <div
              v-for="(priceItem,index) in ordersData.priceData"
              :key="index"
              class="fare-style-box"
            >
              <div v-if="ordersData.priceData.length===1" class="fare-style-list">
                <div>
                  <p>
                    票面价:
                    <span class="font-10">￥</span>
                    <span>{{priceItem.salePrice}}</span>
                  </p>
                </div>
                <div class="flex-center">
                  <p>税金:</p>
                  <span class="font-10">￥</span>
                  <span>{{priceItem.tax}}</span>
                </div>
                <div class="flex-center">
                  <p>后返:</p>
                  <span>{{(priceItem.afterReturn).toFixed(2)}}%</span>
                </div>
                <div class="flex-center">
                  <p>代理费:</p>
                  <span>{{(priceItem.beforeReturn).toFixed(2)}}%</span>
                </div>
              </div>
              <div v-if="ordersData.priceData.length>1" class="fare-style-people">
                <div v-if="priceItem.passengerType===1" class="flex-center">
                  <div>
                    <p>
                      成人(含税):
                      <span class="font-10">￥</span>
                      <span>{{priceItem.saleTotal}}</span>
                    </p>
                  </div>
                </div>
                <div v-if="priceItem.passengerType===2" class="flex-center">
                  <div>
                    <p>
                      儿童(含税):
                      <span class="font-10">￥</span>
                      <span>{{priceItem.saleTotal}}</span>
                    </p>
                  </div>
                </div>
                <div v-if="priceItem.passengerType===3" class="flex-center">
                  <div>
                    <p>
                      婴儿(含税):
                      <span class="font-10">￥</span>
                      <span>{{priceItem.saleTotal}}</span>
                    </p>
                  </div>
                </div>
              </div>
            </div>
            <div class="flights-fuel flex-center">退改条款
              <div class="flights-fuelP">
                <h2>(仅供参考!请以航空公司为准!)</h2>
                <i></i>
                <p>实际以航司审核为准</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-show="orderInfo.flightType>1" class="df moreFlight">
      <div>
        <div
          v-for="(spaceList,spaceIndex) in airInfo.segmentList"
          :key="spaceIndex"
          class="flex-center"
          style="padding:2px 0;"
        >
          <!-- <span class="space-ico">{{spaceIndex + 1}}</span> -->
          <span v-for="(space,sindex) in spaceList.routeList" :key="sindex">
            {{space.cabinCode}}&nbsp;:&nbsp;{{space.seatsNum}}
            {{(sindex+1)==spaceList.routeList.length?'':'/'}}&nbsp;
          </span>
        </div>
      </div>
      <div
        class="flights-type cursor"
        style="width:100px;position:relative"
        @mouseenter="trunkShow = true"
        @mouseleave="trunkShow = false"
      >
        <i class="iconfont iconiconset0188"></i>行李说明
        <div class="flights-trunk" :class="{'fare-info-animation':trunkShow == true}">
          <span
            v-for="(baggageInformationItem,baggageInformationItemIndex) in airInfo.baggageInformation.split(',')"
            :key="baggageInformationItemIndex"
          >{{baggageInformationItem}}</span>
        </div>
      </div>
      <div class="flights-fuel" style="width:80px;text-align:center">
        <span @mouseenter="clauseShow = true" @mouseleave="clauseShow = false">退改条款</span>
        <div
          class="flights-fuelP"
          :class="{'fare-info-animation':clauseShow == true}"
          style="left: -148%;"
        >
          <h2>(仅供参考!请以航空公司为准!)</h2>
          <i></i>
          <p>实际以航司审核为准</p>
        </div>
      </div>
      <div>
        <span>
          票面价：
          <span class="money_color">￥{{airInfo.priceData[0].salePrice}}</span>
        </span>
      </div>
      <div>
        <span>
          税金：
          <span class="money_color">￥{{airInfo.priceData[0].tax}}</span>
        </span>
      </div>
      <div>
        <span>
          后返点：
          <span class="money_color">{{airInfo.priceData[0].afterReturn}}%</span>
        </span>
      </div>
      <div>
        <span>
          代理费：
          <span class="money_color">{{airInfo.priceData[0].beforeReturn}}%</span>
        </span>
      </div>
    </div>
    <div class="passenger">
      <h2>
        <p>乘客信息</p>
      </h2>
      <div class="passenger-data">
        <div>
          <div class="fare-info-list">
            <span>成人：{{orderInfo.adultCount}}</span>
            <span>儿童：{{orderInfo.childCount}}</span>
            <span>婴儿：{{orderInfo.babyCount}}</span>
            <el-button type="primary" size="mini" @click="setPeopleInfo">设置</el-button>
          </div>
          <!-- <el-select v-model="passengerVal" @change="setPassengerVal">
            <el-option v-for="item in 9" :key="item" :value="item">{{item}}</el-option>
          </el-select>-->
          <div class="passenger_list df" v-for="(item,index) in passenger" :key="index">
            <el-form
              :model="item"
              :rules="rules"
              :ref="'userForm'+index"
              class="passenger-ruleForm df"
            >
              <el-form-item label="姓" prop="lastName" class="psgNameCn">
                <el-input v-model="item.lastName"></el-input>
              </el-form-item>
              <el-form-item label="名" prop="firstName" class="psgNameCn">
                <el-input v-model="item.firstName"></el-input>
              </el-form-item>
              <el-form-item label="性别" prop="gender" class="psgNameCn">
                <el-select v-model="item.gender" placeholder="请选乘客类型">
                  <el-option
                    v-for="item in sexList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                    :disabled="item.disabled"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="乘客类型" prop="type" class="psgType">
                <el-input :value="item.type==1?'成人':item.type==2?'儿童':'婴儿'" :disabled="true"></el-input>
              </el-form-item>
              <el-form-item label="证件类型" class="cardType">
                <el-select v-model="item.idType" placeholder="请选证件类型">
                  <el-option
                    v-for="(item,index) in cardType"
                    :key="index"
                    :label="item.name"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
              <el-form-item
                label="证件号码"
                prop="idNumber"
                v-if="item.idType !== 2"
                style="width:180px"
              >
                <el-input v-model="item.idNumber"></el-input>
              </el-form-item>
              <el-form-item
                label="证件号码"
                prop="idNumber"
                v-if="item.idType === 2"
                style="width:180px"
              >
                <el-input v-model="item.idNumber" @blur="fromIdCard(item.idNumber,item)"></el-input>
              </el-form-item>
              <el-form-item label="证件有效期" class="date-style" prop="idExpiration">
                <!-- <el-input v-model="item.idExpiration"></el-input> -->
                <el-date-picker v-model="item.idExpiration" type="date" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
              <el-form-item label="国籍" prop="nationality" style="width:140px">
                <!-- <el-input v-model="item.nationality"></el-input> -->
                <el-autocomplete
                  v-model="item.nationalityText"
                  :fetch-suggestions="(val,cd)=>querySearch(val,cd,item)"
                  @select="(res)=>handleSelect(res,item)"
                ></el-autocomplete>
              </el-form-item>
              <el-form-item label="出生日期" class="date-style" prop="birthday">
                <!-- <el-input v-model="item.birthday"></el-input> -->
                <el-date-picker v-model="item.birthday" type="date" value-format="yyyy-MM-dd"></el-date-picker>
              </el-form-item>
              <el-form-item label="手机号码" prop="phoneNumber">
                <el-input v-model="item.phoneNumber" style="width:120px"></el-input>
              </el-form-item>
            </el-form>
          </div>
        </div>
      </div>
    </div>
    <div class="contact">
      <h2>
        <p>联系信息</p>
      </h2>
      <div class="contact_list df">
        <el-form
          :model="contact"
          :rules="rules"
          ref="touchFrom"
          label-width="100px"
          class="contact-ruleForm df"
        >
          <el-form-item label="联系人" prop="contactName" class="psgNameCn">
            <el-input v-model="contact.contactName"></el-input>
          </el-form-item>
          <el-form-item label="联系人电话" prop="contactPhone">
            <el-input v-model="contact.contactPhone"></el-input>
          </el-form-item>
          <el-form-item label="邮箱">
            <el-input v-model="contact.contactEmail"></el-input>
          </el-form-item>
          <!-- <el-form-item label="QQ">
            <el-input v-model="contact.contactQQ"></el-input>
          </el-form-item>-->
          <el-form-item label="备注" class="remark">
            <!-- <textarea v-model="contact.remark"></textarea> -->
            <el-input type="textarea" v-model="contact.remark" :autosize="{ minRows: 4}"></el-input>
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="contact">
      <h2>
        <p>票价信息</p>
      </h2>
      <div>
        <table class="table" width="90%">
          <tr>
            <td>订单总价</td>
            <td @mouseover="warningShow = true" @mouseleave="warningShow = false" class="cursor">
              <i>￥</i>
              {{AllPrice}}
            </td>
            <td>成人单人结算价</td>
            <td>
              <i>￥</i>
              {{moneyList.adult.saleTotal}}
            </td>
            <td>儿童单人结算价:</td>
            <td>
              <i>￥</i>
              {{moneyList.child?moneyList.child.saleTotal:0}}
            </td>
          </tr>
          <tr>
            <td>婴儿单人结算价</td>
            <td>
              <i>￥</i>
              {{moneyList.baby?moneyList.baby.saleTotal:0}}
            </td>
            <td></td>
            <td></td>
            <td></td>
            <td></td>
          </tr>
        </table>
        <p class="table-warning" :class="{'warning-show':warningShow}">
          订单总价({{AllPrice}})=
          <span>
            成人单人结算价【
            <span class="font-10">￥</span>
            {{moneyList.adult.saleTotal}}】*成人人数【{{orderInfo.adultCount}}】
          </span>
          <span v-if="moneyList.child">
            + 儿童单人结算价【
            <span class="font-10">￥</span>
            {{moneyList.child.saleTotal}}】*儿童人数【{{orderInfo.childCount}}】
          </span>
          <span v-if="moneyList.baby">
            + 婴儿单人结算价【
            <span class="font-10">￥</span>
            {{moneyList.baby.saleTotal}}】*婴儿人数【{{orderInfo.babyCount}}】
          </span>
        </p>
      </div>
    </div>
    <!-- <div class="remind_box" v-if="ordersData.segmentList[0].routeList[0].changeRefundClause"
    v-for="(item,index) in ordersData.segmentList[0].routeList[0].changeRefundClause" :key="index">
      <p>
        <span>温馨提示:</span>
        <i>{{item.change}}</i>
      </p>
      <p>
        <span>工作时间:</span>
        <i>{{ordersData[0].policy.providerWorkTime}}</i> 
      </p>
      <p>
        <span>废票时间:</span>
         <i>{{ordersData[0].policy.refundTime}}</i> 
      </p>
    </div>-->

    <div class="submit_box">
      <button @click="submit()">提交订单</button>
      <div>
        <p class="price">
          <!-- {{PriceText}} -->
          待支付
          <span>
            ￥{{AllPrice}}
            <i>元</i>
          </span>
        </p>
        <p class="contract">
          <el-checkbox v-model="checked"></el-checkbox>我已阅读并同意
          <a @click="goRule" class="cursor">《胤之旅国内旅游机票采购规则》</a>
        </p>
      </div>
    </div>
    <!-- <el-dialog
      title="胤之旅国内旅游机票采购规则"
      :visible.sync="dialogVisible"
      width="50%">
      <p>
        1. 订单生成：您下单生成订单后，不得随意变更订座记录信息，若有变更必须重新下订单；
      </p>
      <p>
        2. PNR重利用说明：对于曾出过票的记录，在平台采购下订单前，需删除PNR内的运价项（FC/FN/FP）、EI备注项、TN票号项及关联项SSR TKNE；
      </p>
      <p>
        3. 订单支付：由于航空公司会根据航班售益状况随时清舱，您下订单后必须及时进行支付，若因没有及时支付被NO位的，由您负责；距航班起飞时间≤2小时的订单，请慎重下单；
      </p>
      <p>
        4. NO位处理：在出票过程中出现NO位的，您应配合平台及时补座位及客人证件信息。如无法补到同舱位的航段，出票过程中≤10分钟被航空公司NO位由您方负责，如因您PNR中存在问题（如航段不连续、PNR无法入库、证件信息不准确等）无法出票，沟通过程中（不限≤10分钟的情况）出现NO位的，由您负责；
      </p>
      <p>
        5. 订单出票结果检查：订单处理完成后，您需自行检查订单处理是否正确（PNR票号有效性、航段状态、价格项和身份证件号码等相关信息），如有问题须及时跟平台客服联系。您检查订单处理无误后须在平台上进行确认操作；
      </p>
      <p>
        6. 客票退改签处理：退票、机票改期、签转将根据不同航空公司、不同舱位的相应规定进行操作，出票后如修改、签转、退票所产生费用由您全额承担；
      </p>
      <p>
        7. 客票变更及处理检查：客票如需变更时，可以根据航空公司客规自行进行变更；如无法自行变更要平台提交变更申请的，由平台负责变更。在平台上提交客票变更申请的，处理完成后，您须自行核对变更信息（PNR中行程、承运人、舱位、改签时间、身份证号码、关联项、用DETR：TN/票号指令检查航段日期时间是否已由OPEN状态改为客户指定的旅行日期时间），检查无误后确认结束订单；
      </p>
      <p>
        8. 客票作废规定：当日客票如需作废，您须按各航空公司规定在航班起飞前提交客票作废申请（B2B客票必须在航班起飞2小时前提交），若因没有及时提交导致无法作废的，由您自行承担。提交客票作废申请前，须取消PNR并作废行程单，当日客票作废按10元/张收费，申请须在当日22：00前提交，若因没有及时取消PNR、作废行程单，或没有在当日22：00前提交，造成的客票作废失败，由您自行承担。客票作废完成后，您必须确认PNR中票号为VOID或REFUNDED状态；若您因实际需求要保留PNR（例：同一名客人在此PNR中存在两个有效票号，其中一个保留），须在退废票申请中明确说明，退款将最终在取消PNR记录或重出票后退回，如因PNR未取消，虚占航空公司机位，出现ADM罚单，由您完全承担；
      </p>
      <p>
        9. 客票退票：在客人确认需退票时，您须第一时间取消PNR并在平台提交退票申请，提交退票申请前须作废行程单，提交退票申请时须注明退票类型，如自愿退票的，须注明按客规退票的费率和手续费金额；如需全退的，须注明原因并提供相关证明，若无相关证明或不能及时提供，导致无法全退或延迟退款的，您自行承担；公司收到航司退款后退给您，以航司实际退款审核金额为准。
      </p>
      <p>
       10. 重出全退规定：如需重出全退的，因各出票地的航空公司有不同规定，重出票或提交全退申请前须与平台客服人员联系确认； 
      </p>
      <p>
        11. 勿重复下单、重复支付：您不能提交支付重复的PNR（同一位乘机人相同时间段两张以上的机票订单），如提交重复订单导致重复出票，所产生的退废票损失由您承担；
      </p>
      <p>
        12. 特殊旅客说明：目前平台只能提供普通旅客服务，对于婴儿及其他有特殊要求的旅客，如病残旅客、孕妇、轮椅旅客，无成人陪伴儿童、VIP要客、国家重要特殊军官军人等，如您在平台采购出票VIP票、儿童票、无成人陪伴儿童票、特殊要客票等，需由您负责向航空公司申报特殊服务要求；
      </p>
      <p>
        13. 失信通知：失信人不得乘飞机。如乘机人属失信人，如未提前说明，机票一旦付全款之后，失信人的机票全损，只能退税，所有损失我司不承担责任！！国家法院失信人验证网站为：http://shixin.court.gov.cn/
      </p>
      <p>
        14. 航班延误通知：平台仅提供各地机票销售政策信息，任何临时发生的航班取消或变动，您自行负责清Q 并及时通知自己的客人，平台不承担任何责任，若出票时平台更换过记录编玛，由平台负责通知您；
      </p>
      <p>
        15. 平台提示信息：交易过程中，您须查看平台上的所有提示信息，这些信息均为采购规则的一部分，须严格遵守；
      </p>
      <p>
        16. 更换编码订单：需采购自行检查原编码是否需要取消;
      </p>
      <p>
        17. 其他事宜：本采购须知中未涉及的交易规则等未尽事宜按国内运输客规规定执行。
      </p>
      <p>
        18. 请确保PNR内容真实准确，虚假PNR出票方有权拒绝出票。
      </p>
      <p>
        19. 请确认PNR的姓名、舱位、航段组正确，请确认舱位状况。
      </p>
      <p>
        20. 请确认每个旅客均已输入SSR FOID项。
      </p>
      <p>
        21. 如有恶意占座、恶意修改PNR内容、恶意签转、联程客票弃程等违反航空公司规定的采购行为，采购方需承担相应责任，平台保留向采购方追偿的权力。
      </p>
      <p>
        22.甲方在承诺期限内完成退款的订单，若与航司审核结果不相符，则以航司审核为准，由此产生的差价则应由乙方负责承担。乙方拒绝承担的，以及违反平台服务规范的，甲方有权限从乙方其他退票单里扣除相应的金额。
      </p>
      <p class="p23">
        23.外国人旅藏的有关规定
        Notes for foreigners to Tibet
        <br>
          <span>
            1）根据国家旅游局规定，外国旅游者、台湾游客和海外华人（香港、澳门居民持中国特区护照或回乡证者除外）在藏期间不允许自行旅游，不论客人人数多少，必须有组织、有计划地组团旅游。
            <br>
            According to the provision from the National Tourism Bureau, foreign visitors, Taiwan visitors and overseas Chinese (except the Hong Kong, Macao residents who hold the passport of Special Administrative Region or the ratification of returning homeland) in Tibet are not allowed to travel by themselves. They must travel in group whatever there are how many visitors.
          </span>
          <span>
            2）鉴于西藏特殊的民族传统、文化古迹和生态环境保护的需要，同时也因西藏的交通状况和旅游服务设施及接待能力，政府规定非中国公民身份持有者，即外国旅游客人，台湾游客及海外华人（香港、澳门居民持中国特区护照或回乡证者除外），在进入西藏旅游前，必须办理由西藏自治区旅游局[TTB]签发的“外国人入藏旅游批准函”，同时，也规定外国记者和外交官不能以旅游者身份进藏。
            Considering the need of Tibet’s special ethnic customs, historical sites and ecological environment, as well as traffic conditions, service facilities and reception places, the government enforces a provision that before travel in Tibet, non-Chinese citizens must handle “the ratification of foreigners’ travel to Tibet”, which need possess a permit by TTB(Tibet Travel Bureau). And these non-Chinese citizens include foreign country visitors, visitors from Taiwan and overseas Chinese (excluding the people in Hong Kong, Macao who hold the passport of special administrative region (SAR) or the ratification of returning homeland), in addition, the government also has another provision that foreign journalists or diplomats can’t enter into Tibet as the visitors.
          </span>
      </p>
      <div>
        <h6>
          平台服务承诺
        </h6>
        <p>
          1. 平台客户服务时间8：00-24：00，出票时间以各政策所发布的信息为准；
        </p>
        <p>
          2. 平台承诺自支付成功起30分钟内完成出票，如超过30分钟未出票导致航空公司NO位的（采购须知中第3、4条情况除外），出票方承担赔偿责任，赔偿限额最高不超所预定舱位票面差价；
        </p>
        <p>
          3. 平台保证正常退/废票及取消交易，在5个工作日（周末和节假日顺延）内完成订单的退/废票或取消交易处理，收到航空公司退票款后并退（除退票费或废票费等航空公司收取的费用外）至采购方支付宝账户；
        </p>
        <p>
          4. 平台只接收在线支付方式，银行卡信息和支付密码在交易中不经过平台系统，直接以安全通道方式递交支付网关，支付网关是受法律保护的支付平台
        </p>
      </div>
      <span slot="footer" class="dialog-footer">
      </span>
    </el-dialog>-->

    <el-dialog title="《胤之旅国内旅游机票采购规则》" :visible.sync="ProcurementRuleShow" width="800px">
      <div v-html="ProcurementRuleText" class="procurement-style"></div>
      <span slot="footer" class="dialog-footer">
        <!-- <el-button type="primary" @click="ProcurementRuleShow = false">确 定</el-button> -->
      </span>
    </el-dialog>
    <el-dialog title="乘客类型" :visible.sync="peopleInfo.show" width="650px">
      <div class="flex-center-end">
        <div class="flex-center-start">
          <p>成人：</p>
          <FareBtn
            :type="'adult'"
            :limitNum="9"
            :defautlNum="peopleInfo.adultCount"
            @getNumber="getNumber"
          />
        </div>
        <div class="flex-center-start">
          <p>儿童 ：</p>
          <FareBtn
            :type="'child'"
            :limitNum="9"
            :defautlNum="peopleInfo.childCount"
            @getNumber="getNumber"
          />
        </div>
        <div class="flex-center-start">
          <p>婴儿：</p>
          <FareBtn
            :type="'baby'"
            :limitNum="4"
            :defautlNum="peopleInfo.babyCount"
            @getNumber="getNumber"
          />
        </div>
      </div>
      <span slot="footer" class="dialog-footer flex-center">
        <el-button @click="peopleInfo.show = false" size="mini">取消</el-button>
        <el-button type="success" @click="peopleInfo.show= false,gainPrice()" size="mini">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import FareBtn from "./components/fareType";
import { ProcurementRuleText } from "../ProcurementRule.js";
import airParams from "@/lib/data-service/flight/flight_international_buyer_white_order_reserve_params";
import reserve from "@/lib/data-service/flight/flight_international_buyer_white_order_reserve";
import countryList from "@/lib/data-service/flight/flight_buyer_country_list";
import checkPrice from "@/lib/data-service/flight/flight_international_buyer_white_order_checkPrice";
import { resolve } from "q";
import { getSession } from "@/lib/deprecated/utils/caching";

export default {
  data() {
    var cardNo = (rule, value, callback) => {
      let reg = /(^\d{18}$)|(^\d{17}(\d|X|x)$)/;
      let re = new RegExp("(^([PSE]{1}\\d{7}|[GS]{1}\\d{8})$)");
      if (reg.test(value) === false) {
        callback(new Error("请输入正确身份证号码"));
      }
    };
    var mobile = (rule, value, callback) => {
      let reg = /^((\+?86)|(\(\+86\)))?(13[012356789][0-9]{8}|15[012356789][0-9]{8}|18[023456789][0-9]{8}|147[0-9]{8}|1349[0-9]{7})$/;
      if (reg.test(value) === false) {
        callback(new Error("请输入正确手机号码"));
      }
    };
    var psgNameCn = (rule, value, callback) => {
      let reg = /^[0-9]+.?[0-9]*$/;
      if (!value) {
        callback(new Error("请输入乘机人姓名"));
      } else if (reg.test(value)) {
        callback(new Error("输入姓名有误！"));
      } else if (value.length < 2) {
        callback(new Error("请输入正确姓名"));
      }
    };
    var detectionEmail = (rule, value, callback) => {
      let reg = /^\w+((-\w+)|(\.\w+))*\@[A-Za-z0-9]+((\.|-)[A-Za-z0-9]+)*\.[A-Za-z0-9]+$/;
      if (reg.test(value) === false) {
        callback(new Error("请输入正确邮箱号码"));
      }
    };
    var detectionQQ = (rule, value, callback) => {
      let reg = /^[1-9][0-9]{4,10}$/gim;
      if (reg.test(value) === false) {
        callback(new Error("请输入正确QQ号码"));
      }
    };
    var inspectName = (rule, value, callback) => {
      let reg = /[A-Za-z]+/;
      if (!value) {
        return callback("请输入姓名");
      }
      if (reg.test(value) === false) {
        callback(new Error("请输入拼音简写"));
      }
    };
    return {
      // 航班信息
      ordersData: null,
      arrowsInfoShow: [],
      peopleInfo: {
        show: false
      },
      clauseShow: null,
      trunkShow: null,
      // 乘客数量
      passengerVal: 1,
      loading: false,

      // 乘客类型
      psgTypeOption: [
        {
          value: 1,
          label: "成人",
          disabled: false
        },
        {
          value: 2,
          label: "儿童",
          disabled: false
        },
        {
          value: 3,
          label: "婴儿",
          disabled: false
        }
      ],
      sexList: [
        {
          value: "MALE",
          label: "男"
        },
        {
          value: "FEMALE",
          label: "女"
        }
      ],
      fareList: [],
      // 联系人信息
      contact: {
        contactEmail: "",
        contactName: "",
        remark: "",
        contactPhone: "",
        contactQQ: ""
      },
      ProcurementRuleText: ProcurementRuleText,
      // 旅客证件
      cardType: [
        { value: 1, name: "护照" },
        { value: 2, name: "身份证" },
        { value: 3, name: "其他" }
      ],
      // 是否同意胤之旅规则
      checked: false,
      warningShow: false,
      // 乘客信息
      passenger: [
        {
          birthday: "",
          firstName: "",
          gender: "MALE",
          idExpiration: "",
          idNumber: "",
          idType: 1,
          lastName: "",
          nationality: "",
          phoneNumber: "",
          pnr: "",
          type: 1
        }
      ],
      ProcurementRuleShow: false,
      // 乘客类型
      psgType: 3,
      // 输入框验证规则
      rules: {
        cardNo: [{ validator: cardNo, required: true, trigger: "blur" }],
        idNumber: [
          { required: true, message: "请填写证件号码", trigger: "blur" }
        ],
        birthday: [
          { required: true, message: "请选择出生日期", trigger: "change" }
        ],
        phoneNumber: [{ validator: mobile, required: true, trigger: "blur" }],
        psgNameCn: [{ validator: psgNameCn, required: true, trigger: "blur" }],
        contactName: [
          { validator: psgNameCn, required: true, trigger: "blur" }
        ],
        idExpiration: [
          { required: true, message: "请选择证件有效期", trigger: "change" }
        ],
        firstName: [
          { validator: inspectName, required: true, trigger: "blur" }
        ],
        lastName: [{ validator: inspectName, required: true, trigger: "blur" }],
        contactPhone: [{ validator: mobile, required: true, trigger: "blur" }],
        contactEmail: [
          { validator: detectionEmail, required: true, trigger: "blur" }
        ],
        contactQQ: [
          { validator: detectionQQ, required: true, trigger: "blur" }
        ],
        nationality: {
          required: true,
          message: "搜索后选择国籍",
          trigger: "change"
        }
      },
      // 成人数量
      adultNub: 1,
      // 儿童数量
      childNub: 0,
      babyNub: 0,
      dialogVisible: false,
      invoicePrice: 0,
      moneyList: {},
      taxes: 0,
      AllPrice: 0,
      PriceText: "",
      rate: 1,
      picList: [],
      image_url_airline_blank_map: `https://lyn.oss-cn-shenzhen.aliyuncs.com/temp/airline-blank-map.jpg`,
      formData: {},
      nationalityList: []
    };
  },
  components: { FareBtn },

  methods: {
    // 计算周几
    Getweek(time) {
      var str = "";
      var week = new Date(time).getDay();
      if (week == 0) {
        str = "星期日";
      } else if (week == 1) {
        str = "星期一";
      } else if (week == 2) {
        str = "星期二";
      } else if (week == 3) {
        str = "星期三";
      } else if (week == 4) {
        str = "星期四";
      } else if (week == 5) {
        str = "星期五";
      } else if (week == 6) {
        str = "星期六";
      }
      return str;
    },
    goRule() {
      this.ProcurementRuleShow = true;
    },
    // 通过身份证获取生日
    fromIdCard(val, list) {
      let birthday = "";
      if (val != null && val != "") {
        if (val.length == 15) {
          birthday = "19" + val.substr(6, 6);
        } else if (val.length == 18) {
          birthday = val.substr(6, 8);
        }
        birthday = birthday.replace(/(.{4})(.{2})/, "$1-$2-");
      }
      list.birthday = birthday;
    },
    getCountryList() {
      countryList().then(res => {
        if (res.code == this.SUCCESS_CODE) {
          this.nationalityList = res.countrys;
        }
      });
    },
    // 获取信息并计算价格
    getAirParams() {
      let _s = sessionStorage.getItem("userInfo");
      let _this = this;
      let orderInfo, airInfo, airSegmentInfo;
      this.airInfo = airInfo = getSession("AIRINFO");
      this.airSegmentInfo = airSegmentInfo = 
        getSession("AIRSEGMENTINFO")
      
      this.orderInfo = orderInfo = getSession("ORDERINFO")
      let passengerNum =
        orderInfo.adultCount + orderInfo.babyCount + orderInfo.childCount;
      this.passengerVal = Number(passengerNum);
      delete orderInfo.pageSize;
      delete orderInfo.currentPage;
      delete orderInfo.orderField;
      delete orderInfo.orderType;
      delete orderInfo.takeOffInterval;

      this.airInfo.priceData.map(item => {
        item.passengerType === 1
          ? (this.moneyList.adult = item)
          : item.passengerType === 2
            ? (this.moneyList.child = item)
            : (this.moneyList.baby = item);
      });
      let _obj = {
        beginTime: airInfo.beginTime,
        cabinCodes: airInfo.cabinCodes,
        flightNo: airInfo.flightNo,
        planeTypes: airInfo.planeTypes,
        ticketAirLineCode: airInfo.ticketAirline,
        supplierId: airInfo.supplierId
      };
      let data = Object.assign(orderInfo, _obj);
      this.formData = data;
      this.ordersData = airInfo;
      this.gitPrice();
    },
    setPeopleInfo() {
      this.peopleInfo.show = true;
      let data = {
        childCount: this.orderInfo.childCount,
        adultCount: this.orderInfo.adultCount,
        babyCount: this.orderInfo.babyCount
      };
      this.peopleInfo = Object.assign(this.peopleInfo, data);
    },
    // 深克隆
    deepClone(obj) {
      let _obj = JSON.stringify(obj);
      let objClone = JSON.parse(_obj);
      return objClone;
    },
    // 计算成人数量
    compAdultNub(data) {
      return data.psgType === 1;
    },
    // 计算儿童数量
    compChildNub(data) {
      return data.psgType === 2;
    },
    // 底部文字部分
    gitPrice() {
      let list = this.moneyList;
      // console.log(this.airInfo)
      let people = this.orderInfo;
      for (let i in list) {
        if (list[i].passengerType === 1) {
          var _a = list[i].saleTotal * people.adultCount;
        } else if (list[i].passengerType === 2) {
          var _b = list[i].saleTotal * people.childCount;
        } else {
          var _c = list[i].saleTotal * people.babyCount;
        }
      }
      this.AllPrice = (
        _a +
        (_b ? _b : 0) +
        (_c ? _c : 0) +
        this.airInfo.yzlBillingFee
      ).toFixed(2);
      // if (this.orderInfo.flightType == 2) {
      //   this.AllPrice = this.AllPrice * 2;
      // }
    },
    querySearch(queryString, cb, items) {
      let restaurants = this.nationalityList;
      let results;
      results = queryString
        ? restaurants.filter(this.createStateFilterAirLines(queryString))
        : [];

      cb(results);
      // results.length === 0 ? (items.nationalityText = "") : "";
    },
    handleSelect(val, item) {
      item.nationality = val.code;
    },
    createStateFilterAirLines(queryString) {
      return state => {
        if (state.cnName.indexOf(queryString) != -1) {
          state.value = state.cnName;
          return state;
        } else if (state.enName.indexOf(queryString.toUpperCase()) != -1) {
          state.value = state.cnName;
          return state;
        }
      };
    },
    gainPrice() {
      let data = Object.assign(this.formData, this.peopleInfo);
      this.loading = true;
      airParams(data).then(
        res => {
          this.ordersData = res.flights[0];
          this.loading = false;
          this.getFare(this.peopleInfo);
          res.flights[0].priceData.map(item => {
            item.passengerType === 1
              ? (this.moneyList.adult = item)
              : item.passengerType === 2
                ? (this.moneyList.child = item)
                : (this.moneyList.baby = item);
          });
          this.gitPrice();
        },
        () => {
          this.loading = false;
        }
      );
    },
    // 提交表单
    submit() {
      let segmentListArr = [];
      let formArr = ["touchFrom"];
      let _this = this;
      segmentListArr = this.ordersData.segmentList.map(item => {
        let arr = [];
        arr = item.routeList.map(sitem => {
          let _a = {
            sTerminal: sitem.sTerminal,
            eCityCode: sitem.eCityCode,
            arriveDate: sitem.arriveDate,
            planeType: sitem.planeType,
            arriveTime: sitem.arriveTime,
            cabinCode: sitem.cabinCode,
            duration: sitem.duration,
            eAirportCode: sitem.eAirportCode,
            eTerminal: sitem.eTerminal,
            beginDate: sitem.beginDate,
            flightNo: sitem.flightNo,
            codeShare: sitem.codeShare,
            airCompanyCode: sitem.airCompanyCode,
            beginTime: sitem.beginTime,
            sCityCode: sitem.sCityCode,
            segmentId: item.segmentId,
            cabinRank: this.orderInfo.cabinRank,
            sAirportCode: sitem.sAirportCode
          };
          return _a;
        });
        let segment = {
          segmentType: item.segmentType,
          routeList: arr
        };
        return segment;
      });

      function verify(arr) {
        let statu = [];
        arr.map((formName, index) => {
          let _a = _this.$refs[formName][0] || _this.$refs[formName];
          _a.validate(valid => {
            if (valid) {
              statu.push(true);
            } else {
              statu.push(false);
            }
          });
        });
        return statu;
      }

      function verifyArr() {
        let arr = [];
        _this.passenger.map((item, index) => {
          return arr.push("userForm" + index);
        });
        return new Promise(resolve => resolve(arr));
      }
      let priceData = {
        adultCount: this.orderInfo.adultCount,
        airline: this.ordersData.ticketAirline,
        babyCount: this.orderInfo.babyCount,
        childCount: this.orderInfo.childCount,
        segmentList: this.ordersData.segmentList,
        supplierId: this.ordersData.supplierId
      };
      if (!this.checked) {
        return this.$message({
          message: "请同意《胤之旅国内旅游机票采购规则》",
          type: "error"
        });
      }
      function submitOrder() {
        return new Promise(resolve => {
          checkPrice(priceData).then(res => {
            if (!res.status) {
              return _this.$message({
                type: "warning",
                message: "价格有差异,该订单无法支付!"
              });
            }
            resolve(res);
          });
        });
      }

      verifyArr().then(array => {
        let statu = verify(formArr.concat(array));
        console.log(statu);
        if (statu.indexOf(false) == -1) {
          _this.loading = true;
          submitOrder().then(val => {
            let data = {
              flightId: this.ordersData.flightId,
              inquiryNumber: val.serialNumber,
              isConvert: val.isConvert,
              noticeMobileNumber: this.contact.contactPhone,
              officeNumber: this.ordersData.officeNumber,
              serialNumber: this.ordersData.serialNumber,
              supplierId: this.ordersData.supplierId,
              ticketAirlineCode: this.ordersData.ticketAirline,
              passengerList: this.passenger,
              segmentList: segmentListArr
            };
            data = Object.assign(data, this.contact);
            console.log(data);
            reserve(data).then(
              res => {
                _this.loading = false;
                this.$router.push({
                  name: "international-pay",
                  query: {
                    ordersNo: res.orderNo,
                    type: "international"
                  }
                });
              },
              () => {
                _this.loading = false;
              }
            );
          });
        }
      });
    },
    getFare(val) {
      let orderInfo;
      val ? (orderInfo = val) : (orderInfo = this.orderInfo);
      let adultCount = [],
        babyCount = [],
        childCount = [];
      function getNewArr(arr, length, type) {
        let passenger = {
          birthday: "",
          firstName: "",
          gender: "MALE",
          idExpiration: "",
          idNumber: "",
          idType: 1,
          lastName: "",
          nationality: "",
          phoneNumber: "",
          pnr: "",
          type: 1
        };
        for (let i = 0; i < length; i++) {
          passenger.type = type;
          arr.push(passenger);
        }
      }
      orderInfo.adultCount > 0
        ? getNewArr(adultCount, orderInfo.adultCount, 1)
        : "";
      orderInfo.babyCount > 0
        ? getNewArr(babyCount, orderInfo.babyCount, 3)
        : "";
      orderInfo.childCount > 0
        ? getNewArr(childCount, orderInfo.childCount, 2)
        : "";
      let arr = [...adultCount, ...babyCount, ...childCount];
      console.log(arr);
      this.passenger = JSON.parse(JSON.stringify(arr));
    },
    getNumber(val) {
      //  let adult = this.orderInfo.adultCount
      //  let child = this.orderInfo.childCount
      //  let baby = this.orderInfo.babyCount
      //  if(val.type==='adult'){
      //   if(adult>=val.num){
      //       val.minus = adult - val.num
      //   }else{
      //       val.add = val.num - adult
      //   }
      //   this.orderInfo.adultCount = val.num
      // }else if(val.type==='child'){
      //   if(child>=val.num){
      //       val.minus = child - val.num
      //   }else{
      //       val.add = val.num - child
      //   }
      //   this.orderInfo.childCount = val.num
      // }else{
      //   if(baby>=val.num){
      //       val.minus = baby - val.num
      //   }else{
      //       val.add = val.num - baby
      //   }
      //   this.orderInfo.babyCount = val.num
      // }
      // this.setPassengerVal(val)
      let people = this.peopleInfo;
      if (val.type === "adult") {
        people.adultCount = val.num;
      } else if (val.type === "child") {
        people.childCount = val.num;
      } else {
        people.babyCount = val.num;
      }
    },
    setPassengerVal(val) {
      let list = this.passenger;
      let _this = this;
      let passenger = {
        birthday: "",
        firstName: "",
        gender: "MALE",
        idExpiration: "",
        idNumber: "",
        idType: 1,
        lastName: "",
        nationality: "",
        phoneNumber: "",
        pnr: "",
        type: 1
      };
      if (val.add >= 0) {
        if (val.type == "adult") {
          passenger.type = 1;
        } else if (val.type == "child") {
          passenger.type = 2;
        } else {
          passenger.type = 3;
        }
        list.push(passenger);
      } else {
        if (val.type == "adult") {
          setArr(list, 1);
        } else if (val.type == "child") {
          setArr(list, 2);
        } else {
          setArr(list, 3);
        }
      }
      function setArr(list, type) {
        for (let i = 0; i < list.length; i++) {
          if (list[i].type === type) {
            _this.passenger.splice(i, 1);
            return;
          }
        }
      }
    }
  },
  watch: {},
  created() {
    this.getAirParams();
    this.getFare();
    this.getCountryList();
  }
};
</script>

<style lang="less" scoped>
.red {
  color: red;
  font-style: normal;
}
.fare-type {
  display: block;
}
.dialog-footer {
  .el-button {
    border-radius: 0;
  }
}
.fare-info-list {
  font-size: 13px;
  padding: 0 0 20px 15px;
  color: #7b7b7b;
  span {
    padding: 0 10px;
  }
  .el-button {
    border: none;
    border-radius: 0;
    background: #237dc8;
  }
}
.fare-style {
  width: 90%;
  margin: auto;
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 14px;
  span {
    color: #ff6600;
  }
  .fare-style-box {
    width: 80%;
    .fare-style-list {
      display: flex;
      justify-content: space-around;
    }
  }
}
.date-style {
  width: 130px;
  /deep/.el-input {
    input {
      width: 130px;
      padding-right: 0;
    }
  }
}
.airOrders {
  width: 1170px;
  margin: 30px auto;
}
.df {
  align-items: center;
  display: flex;
}

.flights-content {
  position: relative;
  border: solid 1px #ffb27f;
  margin-bottom: 10px;
  padding-bottom: 10px;
  background-color: #fffcfa;
  .flights-icon {
    position: absolute;
    left: 0;
    top: 0;
    background: #ffb27f;
    width: 70px;
    height: 20px;
    line-height: 20px;
    color: #ffff;
    text-align: center;
    font-size: 12px;
  }
  .flights-contentT {
    height: 104px;
    font-size: 13px;
    justify-content: space-around;
    text-align: center;
    .flights-type {
      color: #237dc8;
      text-align: center;
    }
    .flights-data {
      justify-content: space-around;
      h5 {
        font-size: 23px;
        color: #393b3e;
        font-weight: bold;
      }
      span {
        font-size: 13px;
        color: #929292;
      }
    }
    .flights-nub {
      justify-content: space-around;
      font-size: 13px;
      align-items: center;
      position: relative;
      height: 100%;
      img {
        width: 32px;
        height: 32px;
        overflow: hidden;
        border-right: 50%;
        margin-right: 20px;
      }
      span {
        font-size: 16px;
        color: #666;
        font-weight: bold;
      }
      p {
        text-align: center;
        color: #999;
        margin-top: 2px;
        i {
          font-style: normal;
        }
      }
    }
    .flights-star {
      h5 {
        color: #393b3e;
      }
      span {
        display: block;
        color: #999;
        text-align: right;
        margin-top: 5px;
      }
    }
    .flights-end {
      h5 {
        color: #393b3e;
      }
      span {
        display: block;
        color: #999;
        text-align: left;
        margin-top: 5px;
      }
    }
    .arrows {
      width: 90px;
      height: 38px;
      margin-top: 30px;
      border-top: 2px solid #a3a3a3;
      color: #929292;
      position: relative;
      text-align: center;
      margin: 30px 30px 0;
      p {
        padding-top: 8px;
      }
      &::after {
        position: absolute;
        top: -7px;
        left: 100%;
        content: "";
        width: 0;
        height: 0;
        border: 7px solid transparent;
        border-left: 7px solid #a3a3a3;
      }
      .arrows-ico {
        width: 15px;
        height: 15px;
        position: absolute;
        top: 0;
        left: 50%;
        transform: translate(-50%, -8px);
        border-radius: 50%;
        color: #fff;
        background: #227dc8;
        border: 2px solid white;
        box-shadow: 0 0 5px #227dc8;
        cursor: pointer;
      }
    }
    .flights-catering {
      color: #666666;
    }
    .flights-more {
      color: #ff6600;
      padding: 0 15px;
      font-size: 14px;
      line-height: 28px;
      cursor: pointer;
      i {
        vertical-align: middle;
        margin-left: 5px;
      }
    }
  }
}
/deep/.el-dialog .procurement-style {
  p {
    padding: 5px 0;
    font-size: 14px;
    letter-spacing: 2px;
    text-align: justify;
  }
}
.table {
  margin: auto;
  margin-top: 20px;
  margin-bottom: 20px;
  border-collapse: collapse;
  th {
    font-size: 13px;
  }
  td {
    text-align: center;
    font-size: 12px;
    i {
      font-size: 10px;
      font-style: normal;
    }
  }
}
table td,
table th {
  border: 1px solid #cad9ea;
  color: #666;
  height: 30px;
}
.table-warning {
  font-size: 13px;
  color: red;
  padding: 0 0 10px 0;
  text-align: center;
  opacity: 0;
  transition: opacity 0.5s ease;
}
.warning-show {
  opacity: 1;
}
.passenger,
.contact {
  border: 1px solid #e9e9e9;
  margin-bottom: 20px;
  h2 {
    height: 40px;
    line-height: 40px;
    font-size: 18px;
    background: #237dc8;
    color: #4b4b4b;
    padding-left: 8px;
    p {
      background-color: #ecf6ff;
      vertical-align: middle;
      padding-left: 20px;
    }
  }
}
.passenger-data {
  padding: 20px 0;
  .passengerVal {
    padding-left: 5px;
    height: 38px;
    outline: none;
    margin-left: 10px;
    width: 150px;
    border-radius: 5px;
    border: 1px solid #e9e9e9;
  }
  .passenger_list {
    justify-content: space-around;
  }
  .passenger-ruleForm {
    width: 100%;
    justify-content: space-between;
    // margin-top: 15px;
    background: #f3f9fe;
    padding: 10px 5px;
    .psgNameCn,
    .psgType,
    .cardType,
    .birthday {
      width: 90px;
    }
    .psgType {
      /deep/.el-input {
        input {
          color: black;
          background: white;
        }
      }
    }
  }
}
.arrows-stop-info {
  min-width: 750px;
  display: none;
  color: #6b6b6b;
  background: white;
  position: absolute;
  top: 35px;
  left: -365%;
  z-index: 999;
  box-shadow: 0 3px 5px #999;
  .arrows-stop-info-title {
    text-align: center;
    padding: 10px 0;
    background: #f4f9ff;
  }
  .arrows-stop-info-box {
    padding: 10px 30px;
    .info-box-title {
      padding: 5px 0 10px 0;
      letter-spacing: 1px;
    }
    .info-box-list-hint {
      padding: 0 0 10px 0;
      span {
        font-size: 10px;
      }
      .info-box-list-hint-box::after {
        content: "";
        display: inline-block;
        width: 25%;
        height: 1px;
        background: #dfdfdf;
      }
      .info-box-list-hint-box::before {
        content: "";
        display: inline-block;
        width: 20%;
        height: 1px;
        background: #dfdfdf;
      }
    }
    .info-box-list {
      background: #f4f9ff;
      padding: 10px;
      margin-bottom: 10px;
      img {
        width: 30px;
        height: 30px;
        border-radius: 50%;
        border: 1px solid #999;
      }
      p {
        line-height: 20px;
        font-size: 12px;
      }
      .info-box-text {
        span {
          display: inline-block;
          padding: 0 10px;
          text-align: center;
          color: #227dc8;
          line-height: 30px;
        }
      }
    }
  }
}
.contact_list {
  flex-direction: column;
  .contact-ruleForm {
    width: 90%;
    margin: auto;
    margin-top: 20px;
    justify-content: space-between;
    flex-wrap: wrap;
    /deep/.el-input {
      input {
        width: 220px;
      }
    }
    .remark {
      width: 100%;
      textarea {
        width: calc(100% - 5px);
        height: 100px;
        border-color: #c0c4cc;
        border-radius: 5px;
      }
    }
  }
}
.remind_box {
  background-color: #fffcfa;
  border: solid 1px #ffb27f;
  padding: 10px 20px;
  margin-bottom: 20px;
  p {
    display: flex;
    line-height: 1.5;
    font-size: 14px;
    span {
      display: block;
      width: 80px;
      margin-right: 10px;
    }
    i {
      display: block;
      width: calc(100% - 90px);
      font-style: normal;
    }
  }
}
.submit_box {
  background-color: #fffcfa;
  border: solid 1px #ffb27f;
  padding: 35px;
  display: flex;
  flex-direction: row-reverse;
  align-items: center;
  button {
    width: 113px;
    height: 38px;
    background: #ff6600;
    border: none;
    outline: none;
    color: #fff;
    font-size: 18px;
    margin-left: 50px;
    cursor: pointer;
  }
  .price {
    color: #666;
    text-align: right;
    font-size: 16px;
    span {
      color: #ff6600;
      font-size: 26px;
      i {
        font-size: 16px;
        font-style: normal;
      }
    }
  }
  .contract {
    margin-top: 5px;
    font-size: 12px;
    text-align: right;
    a {
      text-decoration: none;
      color: #237dc8;
    }
  }
}
.flights-contentB {
  justify-content: space-around;
  height: 20px;
  color: #666;
  font-size: 14px;
  span {
    color: #ff6600;
  }
  line-height: 20px;
}
.flights-fuel {
  color: #237dc8;
  width: 20%;
  position: relative;
  cursor: pointer;
  .flights-fuelP {
    position: absolute;
    text-align: center;
    top: 30px;

    display: none;
    width: 300px;
    padding: 5px;
    background: #fff;
    border: 1px solid #237dc8;
    color: #ff6600;
    z-index: 1;
    i {
      position: absolute;
      border: 1px solid #237dc8;
      background: #fff;
      height: 10px;
      transform: rotate(45deg);
      width: 10px;
      top: -6px;
      border-right: none;
      border-bottom: none;
    }
    h2 {
      font-size: 16px;
      line-height: 30px;
    }
    p {
      padding: 5px;
    }
  }
  &:hover .flights-fuelP {
    display: block;
  }
}
.airOrders {
  /deep/.el-dialog__header {
    background: #ecf6ff;
    .el-dialog__title {
      color: #666;
    }
  }
  /deep/.el-dialog__body {
    p {
      text-indent: 2em;
      line-height: 1.5;
      span {
        display: block;
        text-indent: 2em;
        line-height: 1.5;
      }
    }
    .p23 {
      text-indent: 0em;
      padding: 0 2em;
      margin-bottom: 20px;
    }
    div {
      h6 {
        font-size: 16px;
        margin-bottom: 20px;
      }
    }
  }
  .productTypeTxt {
    color: #ff6600;
  }
}
.fare-info-animation {
  display: block !important;
  animation: fareAnimation 0.5s ease;
}
@keyframes fareAnimation {
  0% {
    opacity: 0;
    transform: translateY(20%);
  }
  100% {
    opacity: 1;
    transform: translate(0);
  }
}
/deep/.el-input {
  input {
    border-radius: 0;
  }
}
.moreFlight {
  padding: 5px 40px;
  background: #ecf6ff;
  justify-content: space-around;
  font-size: 13px;
  margin-bottom: 10px;
  .money_color {
    color: #ff6600;
  }
}
.flights-trunk {
  position: absolute;
  left: -90px;
  top: 30px;
  display: none;
  width: 300px;
  background: #fff;
  border: 1px solid #237dc8;
  color: #237dc8;
  padding: 10px;
  word-wrap: break-word;
  z-index: 1;
  span {
    padding: 3px 10px;
  }
}
</style>
